import { motion } from "framer-motion";
import { urgency } from "@/mocks/models";
import DownloadMotionLink from "@/components/DownloadMotionLink";

export default function UrgencyBar() {
  return (
    <section className="px-4 py-3">
      <DownloadMotionLink
        downloadType="button"
        className="flex items-center gap-3 rounded-xl bg-accent-500/15 p-3 cursor-pointer"
        whileHover={{ scale: 1.02, backgroundColor: "oklch(var(--accent-500) / 0.25)" }}
        whileTap={{ scale: 0.98 }}
        animate={{
          boxShadow: [
            "0 0 0 0 oklch(var(--accent-500) / 0)",
            "0 0 0 6px oklch(var(--accent-500) / 0.1)",
            "0 0 0 0 oklch(var(--accent-500) / 0)",
          ],
        }}
        transition={{
          boxShadow: {
            repeat: Infinity,
            duration: 2.5,
            ease: "easeInOut",
          },
        }}
      >
        <div className="h-12 w-12 flex-shrink-0 overflow-hidden rounded-full">
          <img
            src={urgency.avatar}
            alt="カミラ"
            className="h-full w-full object-cover object-top"
          />
        </div>
        <div className="min-w-0 flex-1 text-sm leading-snug">
          <span className="font-bold text-accent-400">{urgency.name}</span>
          <span className="text-foreground-300">が</span>
          <span className="text-foreground-300">
            秘密の部屋を開けました！今すぐクリックしてライブで見てみて！
          </span>
          <motion.span
            className="ml-1 inline-block text-accent-400"
            animate={{ rotate: [0, 15, -15, 10, 0] }}
            transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut", repeatDelay: 1 }}
          >
            👋
          </motion.span>
        </div>
      </DownloadMotionLink>
    </section>
  );
}